import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface ICeaseState {
  className?: string;
  state: string;
}

const normaliseStateClass = (state: string): string => {
  return state
    .trim()
    .toLowerCase()
    .replaceAll(/\s+/g, '_')
    .replaceAll(/[^a-z0-9_]/g, '');
};

const CeaseState: FunctionComponent<React.PropsWithChildren<ICeaseState>> = ({ className, state }) => (
  <span data-testid="cease-state" className={`state ${normaliseStateClass(state)} ${className ?? ''}`.trim()}>
    {state.toUpperCase().replaceAll('_', ' ')}
  </span>
);

const StyledCeaseState = styled(CeaseState)`
  display: inline-block;
  color: white;
  font-family: ${(props) => props.theme.typography.fontFamilyBold};
  text-align: center;
  border-radius: 0.7em;
  font-size: 0.8em;
  padding: 0 1em;

  &.pending_processing,
  &.pending {
    background-color: ${(props) => props.theme.colours.secondaryD1};
  }

  &.submitted {
    background-color: ${(props) => props.theme.colours.primaryC1};
  }

  &.placed {
    background-color: ${(props) => props.theme.colours.primaryB1};
  }

  &.failed {
    background-color: ${(props) => props.theme.colours.secondaryA1};
  }
`;

export default StyledCeaseState;
